import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        position: 'relative',
        width: '100%',
    },
    inner: {
        paddingBottom: '10px',
        width: '100%',
    },
    cardInner: {
        transition: 'all .3s',
        boxShadow: ' 0 0 8px 0 rgba(0, 0, 0, 0.15)',
        borderRadius: '4px',
    },
    card: {
        borderRadius: '4px',
        boxShadow: 'none',
        padding: '10px 13px',
        position: 'relative',
        display: 'flex',
        gap: '6px',
        width: '100%',
        flexDirection: 'column',
        transition: 'all .3s',
        border:'2px solid transparent',
        '.lightTheme &': {
            backgroundColor: '#fff',
        },
        '&.complete': {
            backgroundColor: SV_LIGHT.accentSoft,
            '.darkTheme &': {
                backgroundColor: '#90caf9',
                color: '#000'
            },
        },
        '&.active': {
            boxShadow:'0px 4px 10px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#f0f8ff',
            border:`2px solid ${SV_LIGHT.accent}`,
            '.darkTheme &': {
                color: '#000'
            },
        },

        '&.hasTasks': {
            borderRadius: '4px 4px 0 0 ',
        },
        '.hover:hover &': {
            cursor: 'pointer',
            border: `2px solid ${SV_LIGHT.accent}`,
        },
    },
    name: {
        fontSize: '12px',
        fontWeight: '700',
        '.lightTheme &': {
            color: '#1c1b1f',
        },
    },
    tasksInfo: {
        card: {
            transition: 'all .3s',
            borderRadius: '0 0 4px 4px',
            boxShadow: 'none',
            border: '1px solid transparent',
            '.hover:hover &': {
                cursor: 'pointer',
                border: `1px solid ${SV_LIGHT.accent}`,
            },
        }
    }
}